import Button from '@mui/material/Button';

type Props = {
    isValid: boolean,
    isSubmitting: boolean,
    text: string
};

export default function SubmitButton(props: Props) {

  return (
    <Button disabled={!props.isValid || props.isSubmitting} className="primary login" size="small" type="submit">{props.text}</Button>
  );
}